import {FC, PropsWithChildren} from 'react';
import {Box} from '@mui/material';
import {cardSx} from './TableCard.sx';

export const TableCard: FC<PropsWithChildren> = ({children}) => {
    return <Box sx={cardSx}>{children}</Box>;
};
